import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {map} from 'rxjs';
import {MaterialModule} from '../../material.module';
import {
    getPublicProductPage,
    PUBLIC_PRODUCT_FEATURE_TABLE_COLUMNS,
    PUBLIC_PRODUCT_NAV_ITEMS,
    PUBLIC_PRODUCT_PAGES,
    PublicProductExclusion,
    PublicProductFeatureGroup,
    PublicProductFeatureValueRow,
    PublicProductPageContent,
} from './public-product-content';

@Component({
    selector: 'app-public-product-page',
    standalone: true,
    imports: [CommonModule, RouterLink, MaterialModule],
    templateUrl: './public-product-page.component.html',
    styleUrls: ['./public-product-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductPageComponent {
    private readonly route = inject(ActivatedRoute);

    readonly products = PUBLIC_PRODUCT_NAV_ITEMS;
    readonly featureTableColumns = PUBLIC_PRODUCT_FEATURE_TABLE_COLUMNS;
    readonly product$ = this.route.paramMap.pipe(
        map(params => getPublicProductPage(params.get('slug')) ?? PUBLIC_PRODUCT_PAGES.ai)
    );

    trackValue(index: number, value: string): string {
        return value;
    }

    trackFeatureGroup(index: number, group: PublicProductFeatureGroup): string {
        return group.title;
    }

    trackFeatureValueRow(index: number, row: PublicProductFeatureValueRow): string {
        return row.feature;
    }

    trackProduct(index: number, product: PublicProductPageContent): string {
        return product.slug;
    }

    trackExclusion(index: number, exclusion: PublicProductExclusion): string {
        return `${exclusion.status}-${exclusion.label}`;
    }
}
